import { Component, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { SheetsAppStateService } from '@modules/sheets/services/state.service';

import { Sheet } from '@modules/sheets/types/sheet';
import { SheetFolder } from '@modules/sheets/types/sheet-folder';

import { FullFormBaseComponent } from '@modules/common/components/full-form-base/full-form-base.component';
import { AbstractMainViewComponent } from '@modules/common/components/main-view/main-view.component';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-sheets-main-view',
  templateUrl: './sheets-main-view.component.html',
  styleUrls: ['./sheets-main-view.component.less'],
  standalone: false,
})
export class SheetsMainViewComponent extends AbstractMainViewComponent<
  StitchType.SHEET | StitchType.SHEET_FOLDER,
  Sheet | SheetFolder,
  FullFormBaseComponent<StitchType.SHEET | StitchType.SHEET_FOLDER, Sheet | SheetFolder, Record<string, AbstractControl>>
> {
  protected override readonly stateService = inject(SheetsAppStateService);

  asSheet(item: Sheet | SheetFolder): Sheet {
    return item as Sheet;
  }

  asSheetFolder(item: Sheet | SheetFolder): SheetFolder {
    return item as SheetFolder;
  }
}
